import React from 'react';
import './styles.scoped.css';

const FormRow = ({ legend, children, className = '', style = {} }) => (
    <fieldset className={`form-row ${className}`} style={style} role="group" aria-label={legend}>
        {legend && <legend className="sr-only">{legend}</legend>}
        {children}
    </fieldset>
);

export default FormRow;
